import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const cardImageSx:SxProps = {
    minHeight:globalBreak({mobile:'unset', desktop:'unset'})
}